if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('[data-localization-input], input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.querySelectorAll('[data-country-flag]').forEach(flag => {
          const code = flag.dataset.countryFlag;
          if (/^[A-Z]{2}$/.test(code)) flag.textContent = [...code].map(letter => String.fromCodePoint(127397 + letter.charCodeAt(0))).join('');
        });
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) {
          // Edition links can contain a stale variant. The destination locale selects its own edition.
          const returnTo = form.querySelector('[name="return_to"]');
          if (returnTo) {
            const destination = new URL(returnTo.value || location.pathname, location.origin);
            destination.searchParams.delete('variant');
            returnTo.value = destination.pathname + destination.search;
          }
          // Shopify CLI returns 401 for localization POSTs. Keep its preview language navigation local.
          if (['127.0.0.1', 'localhost'].includes(location.hostname) && this.elements.input.name === 'language_code') {
            const alternate = [...document.querySelectorAll('link[rel="alternate"][hreflang]')]
              .find(link => link.hreflang === this.elements.input.value);
            if (alternate) {
              const destination = new URL(alternate.href);
              destination.searchParams.delete('variant');
              location.assign(location.origin + destination.pathname + destination.search);
              return;
            }
          }
          form.submit();
        }
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
